(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider', {
            parent: 'entity',
            url: '/provider?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.provider.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider/providers.html',
                    controller: 'ProviderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'lastName,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-detail', {
            parent: 'entity',
            url: '/provider/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.provider.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider/provider-detail.html',
                    controller: 'ProviderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provider', function($stateParams, Provider) {
                    return Provider.get({id : $stateParams.id});
                }]
            }
        })
        .state('provider.new', {
            parent: 'provider',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                firstName: null,
                                lastName: null,
                                contactNumber: null,
                                emailAddress: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('provider', null, { reload: true });
                }, function() {
                    $state.go('provider');
                });
            }]
        })
        .state('provider.edit', {
            parent: 'provider',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-dialog.html',
                    controller: 'ProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider.delete', {
            parent: 'provider',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider/provider-delete-dialog.html',
                    controller: 'ProviderDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Provider', function(Provider) {
                            return Provider.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
